// @view/writing/review/Section.tsx
import React from "react";
import type { Section as SectionType, SectionID } from "@ps-bridge/models/core/dataContracts";
import SectionCard from "./SectionCard";
import SectionActionsPanel from "@view/panels/document/review/SectionActions.panel";

import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import type { StateUpdate } from "@ps-bridge/capabilitiesTypes";
import { sectionActionsPhaseNamespace as sectionActionsPhase } from "@ps-bridge/models/ui/sectionActionsPhase";
import { readOptionString } from "@utils/readOptionString";

type SectionProps = {
  section: SectionType;
  active: boolean;
  setActiveSection: StateUpdate<SectionID>;
} & Pick<DocumentReviewViewProps, "handleRefine" | "handleEdits" | "handleDraft" | "handleUpload">;

const Section: React.FC<SectionProps> = ({
  section,
  active,
  handleRefine,
  handleEdits,
  handleDraft,
  handleUpload,
  setActiveSection,
}) => {
  const hasSectionContents = readOptionString(section.section_contents).trim().length > 0;

  return (
    <>
      <SectionCard
        section={section}
        active={active}
        onPressIo={setActiveSection(section.metadata.id)}
      />
      <SectionActionsPanel
        phase={
          !active
            ? sectionActionsPhase.hidden
            : hasSectionContents
              ? sectionActionsPhase.content
              : sectionActionsPhase.draft
        }
        sectionContents={section.section_contents}
        handleDraft={handleDraft}
        handleRefine={handleRefine}
        handleEdits={handleEdits}
        handleUpload={handleUpload}
      />
    </>
  );
};

export default React.memo(Section, (prevProps, nextProps) => {
  return (
    prevProps.active === nextProps.active &&
    prevProps.section === nextProps.section
  );
});
